<template>
  <export-excel
    class="export_btn"
    :fields="custom_fields"
    :fetch="getData"
    type="csv"
    :name="`${nameText}(${month}_${year})_${admin.township.name}.xls`"
    :footer="[`Township : ${admin.township.name}`, `${month}/${year}`]"
  >
    <v-icon color="white" left>mdi-chevron-right-circle-outline</v-icon>Export
  </export-excel>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    month: { type: Number },
    year: { type: Number },
    volData: {
      type: Array,
    },
    dots: {
      type: Boolean,
    },
  },
  data: () => ({
    custom_fields: {
      Code: "code",
      Name: "name",
    },
  }),
  computed: {
    ...mapState("Admin", ["admin"]),
    nameText() {
      if (this.dots) return "DOTS reported volunteers report";
      return "Reported volunteer";
    },
  },
  methods: {
    getData() {
      if (this.volData.length > 0) return this.volData;
    },
  },
};
</script>

<style scoped>
.export_btn {
  background: #ff4081;
  border-radius: 3px;
  color: white !important;
  letter-spacing: 1px;
  text-transform: uppercase;
  width: 120px;
  padding: 5px 15px;
  margin-bottom: 1px;
  cursor: pointer;
  width: 100%;
  cursor: pointer;
}
</style>
